import { render, staticRenderFns } from "./UserSkills.vue?vue&type=template&id=b18d8430&scoped=true"
import script from "./UserSkills.vue?vue&type=script&lang=ts"
export * from "./UserSkills.vue?vue&type=script&lang=ts"
import style0 from "./UserSkills.vue?vue&type=style&index=0&id=b18d8430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18d8430",
  null
  
)

export default component.exports